import { IconButton, Tooltip } from '@mui/material';
import { Doc } from 'src/@types/docs';
import { useLocales } from 'src/locales';
import { useDocHeaderActions } from '../useDocHeaderActions';
import { DocPinIcon } from './DocPinIcon';

export const PinDocHeaderAction = ({ doc }: { doc: Doc }) => {
  const { toggleDocOnActionBar, isOnActionBar } = useDocHeaderActions({ doc });
  const { translate } = useLocales();
  return (
    <Tooltip
      arrow
      title={
        isOnActionBar
          ? translate('collaborate.docs.remove_from_actions_bar')
          : translate('collaborate.docs.add_to_actions_bar')
      }
    >
      <IconButton onClick={toggleDocOnActionBar}>
        <DocPinIcon isOnActionBar={isOnActionBar} />
      </IconButton>
    </Tooltip>
  );
};
